export const ProjectConfig = {
  api_url: "/api/",
};
